import dayjs from 'dayjs';

/**
 * 해당 날짜의 주에서 가장 첫번째 날을 반환
 *
 * ex. "2024-06-06" -> 2024년 6월 2일
 * @param date
 * @returns
 */
export default function getFirstDayOfWeek(date: Date | string | dayjs.Dayjs) {
  return dayjs(date).day(0);
}
